import { csx } from '@vtex/admin-ui'
import React from 'react'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router'

import { useOrderForm } from '../../../../../../core/requests/checkout'
import { SummarySection } from '..'
import type { ClientProfileInfo } from '../../../../components'
import { ClientProfile } from '../../../../components'
import { getOrderAsPackages } from '../../../../utils/packages'
import { isAnonymous } from '../../../../../../core/utils/orderForm'
import type { ClientDataState } from '../../../../typings'
import { getDeliveryMethodRouteByPackages } from '../../../../utils'

type ClientProfileSectionProps = {
  clientProfileData: ClientDataState
}

export const ClientProfileSection = ({
  clientProfileData,
}: ClientProfileSectionProps) => {
  const { formatMessage } = useIntl()
  const history = useHistory()
  const { orderForm } = useOrderForm()
  const packages = getOrderAsPackages(orderForm)

  const { name, email, document, phone, isCorporate } = clientProfileData ?? {}

  const handleEditInfoClick = (info: ClientProfileInfo) => {
    const nextRoute = getDeliveryMethodRouteByPackages(packages)
    const finalRoute = `${nextRoute}/${info}?edit=true&origin=order-summary`

    history.push(finalRoute)
  }

  if (isAnonymous(orderForm)) {
    return null
  }

  return (
    <SummarySection
      title={formatMessage({
        id: 'checkout.order-summary.customer-profile.title',
      })}
    >
      <ClientProfile
        onEditInfoClick={handleEditInfoClick}
        className={csx({ marginTop: '$space-6' })}
        client={{
          name: name ?? '-',
          email: email ?? '-',
          document: document ?? '-',
          documentType: orderForm?.clientProfileData?.documentType ?? null,
          phone: phone ?? '-',
          isCorporate: isCorporate ?? false,
        }}
      />
    </SummarySection>
  )
}
